function initShareToggle() {
  const shareToggle = document.querySelector('.share__toggle');
  if (shareToggle) {
    shareToggle.addEventListener('click', () => {
      const shareList = shareToggle.nextElementSibling;
      if (!shareList) return;
      shareToggle.classList.remove('share__toggle--visible');
      shareList.classList.add('share__list--visible');
    })
  }
}

export default initShareToggle;
